import { useMemo, useState } from "react";

export const useHealthApi = (data) => {
  const { pending, received, sent, errors, isOk } = useMemo(() => {
    const received = Number(data.i_received ?? 0);
    const sent = Number(data.i_message ?? 0);
    const errors = Number(data.i_errors ?? 0);

    const pending = received - (sent + errors);
    const isOk = pending === 0;

    return {
      received,
      sent,
      errors,
      pending,
      isOk,
    };
  }, [data]);

  return {
    pending,
    received,
    sent,
    errors,
    isOk,
  };
};

export const useHealthApiModal = () => {
  const [visible, setVisible] = useState(false);

  const onOpen = () => setVisible(true);

  const onClose = () => setVisible(false);
  return { visible, setVisible, onOpen, onClose };
};
